/* THIS IS FILE IS AUTO-GENERATED BY graphql-codegen. DO NOT EDIT THIS FILE DIRECTLY! */
/* eslint-disable eslint-comments/no-unlimited-disable */
/* eslint-disable */
import * as Types from "../../types/definitions/vendor/graphql-schema.d";
import { DocumentNode } from "graphql";
import * as Apollo from "@apollo/client";
const defaultOptions = {} as const;
export type ReturnInProgressCancelMutationVariables = Types.Exact<{
  orderId: Types.Scalars["ID"]["input"];
  skuId: Types.Scalars["ID"]["input"];
}>;
export type ReturnInProgressCancelMutation = {
  __typename?: "Mutation";
  returnInProgressCancel?: {
    __typename?: "ReturnInProgressCancelPayload";
    result: {
      __typename?: "ReturnInProgressCancelResult";
      clientItemAction: {
        __typename?: "ClientItemAction";
        id: string;
      };
    };
  } | null;
};
export const ReturnInProgressCancelDocument = {
  kind: "Document",
  definitions: [{
    kind: "OperationDefinition",
    operation: "mutation",
    name: {
      kind: "Name",
      value: "returnInProgressCancel"
    },
    variableDefinitions: [{
      kind: "VariableDefinition",
      variable: {
        kind: "Variable",
        name: {
          kind: "Name",
          value: "orderId"
        }
      },
      type: {
        kind: "NonNullType",
        type: {
          kind: "NamedType",
          name: {
            kind: "Name",
            value: "ID"
          }
        }
      }
    }, {
      kind: "VariableDefinition",
      variable: {
        kind: "Variable",
        name: {
          kind: "Name",
          value: "skuId"
        }
      },
      type: {
        kind: "NonNullType",
        type: {
          kind: "NamedType",
          name: {
            kind: "Name",
            value: "ID"
          }
        }
      }
    }],
    selectionSet: {
      kind: "SelectionSet",
      selections: [{
        kind: "Field",
        name: {
          kind: "Name",
          value: "returnInProgressCancel"
        },
        arguments: [{
          kind: "Argument",
          name: {
            kind: "Name",
            value: "input"
          },
          value: {
            kind: "ObjectValue",
            fields: [{
              kind: "ObjectField",
              name: {
                kind: "Name",
                value: "skuId"
              },
              value: {
                kind: "Variable",
                name: {
                  kind: "Name",
                  value: "skuId"
                }
              }
            }, {
              kind: "ObjectField",
              name: {
                kind: "Name",
                value: "orderId"
              },
              value: {
                kind: "Variable",
                name: {
                  kind: "Name",
                  value: "orderId"
                }
              }
            }]
          }
        }],
        selectionSet: {
          kind: "SelectionSet",
          selections: [{
            kind: "Field",
            name: {
              kind: "Name",
              value: "result"
            },
            selectionSet: {
              kind: "SelectionSet",
              selections: [{
                kind: "Field",
                name: {
                  kind: "Name",
                  value: "clientItemAction"
                },
                selectionSet: {
                  kind: "SelectionSet",
                  selections: [{
                    kind: "Field",
                    name: {
                      kind: "Name",
                      value: "id"
                    }
                  }]
                }
              }]
            }
          }]
        }
      }]
    }
  }]
} as unknown as DocumentNode;
export type ReturnInProgressCancelMutationFn = Apollo.MutationFunction<ReturnInProgressCancelMutation, ReturnInProgressCancelMutationVariables>;

/**
 * __useReturnInProgressCancelMutation__
 *
 * To run a mutation, you first call `useReturnInProgressCancelMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useReturnInProgressCancelMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [returnInProgressCancelMutation, { data, loading, error }] = useReturnInProgressCancelMutation({
 *   variables: {
 *      orderId: // value for 'orderId'
 *      skuId: // value for 'skuId'
 *   },
 * });
 */
export function useReturnInProgressCancelMutation(baseOptions?: Apollo.MutationHookOptions<ReturnInProgressCancelMutation, ReturnInProgressCancelMutationVariables>) {
  const options = {
    ...defaultOptions,
    ...baseOptions
  };
  return Apollo.useMutation<ReturnInProgressCancelMutation, ReturnInProgressCancelMutationVariables>(ReturnInProgressCancelDocument, options);
}
export type ReturnInProgressCancelMutationHookResult = ReturnType<typeof useReturnInProgressCancelMutation>;
export type ReturnInProgressCancelMutationResult = Apollo.MutationResult<ReturnInProgressCancelMutation>;
export type ReturnInProgressCancelMutationOptions = Apollo.BaseMutationOptions<ReturnInProgressCancelMutation, ReturnInProgressCancelMutationVariables>;